{
  "my_calendar": {
    "upcoming": "Upcoming",
    "recent": "Recent",
    "calendar": "Calendar",
    "list": "List",
    "with": "With",
    "edit_key_activity": "Edit Key Activity",
    "mark_as_bd_activity": "Mark as BD Activity",
    "empty_state": {
      "no_meetings_alt": "No Meetings or Activities",
      "no_meetings_title": "No Meetings or Activities",
      "no_events_scheduled": "You have no events scheduled."
    },
    "load_more": {
      "upcoming_complete": "That's all the events for the upcoming month.",
      "past_complete": "That's all the events for the past 3 months."
    }
  }
}
